module.exports = __webpack_public_path__ + "img/1V_l_mdZpkDeKZmHS7DL7-scWLpZaoz1G.8f7a5bc2.png";